import { useSearchParams as useSearchParams } from 'react-router';
import { memo as memo } from 'react';
import { KProperty02ce7r476m8633 as KProperty0 } from '../../../../../../kotlin-kotlin-stdlib/kotlin/reflect/KPropertyJs.mjs';
import {
  getPropertyCallableRef3hckxc0xueiaj as getPropertyCallableRef,
  constructCallableReference23y65rf941mch as constructCallableReference,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import {
  toString1pkumu07cwy4m as toString,
  hashCodeq5arwsb9dgti as hashCode,
  getBooleanHashCode1bbj3u6b3v0a7 as getBooleanHashCode,
  equals2au1ep9vhcato as equals,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import {
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { Paire9pteg33gng7 as Pair } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Tuples.mjs';
import { listOf1jh22dvmctj1r as listOf } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/CollectionsKt.mjs';
import { numberRangeToNumber25vse2rgp6rs8 as numberRangeToNumber } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/rangeTo.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import {
  collectionSizeOrDefault36dulx8yinfqm as collectionSizeOrDefault,
  flatten2dh4kibw1u0qq as flatten,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/Iterables.mjs';
import { Unit_instance3vdlo4e4f5ggx as Unit_instance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { Frame1ci3gictglus as Frame } from '../../../../../../Coupling-client-components/com/zegreatrob/coupling/client/components/FrameRunner.mjs';
import { listOfvhqybd2zx248 as listOf_0 } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/collectionJs.mjs';
import { asSequence2phdjljfh9jhx as asSequence } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import { toIntOrNull3w2d066r9pvwm as toIntOrNull } from '../../../../../../kotlin-kotlin-stdlib/kotlin/text/StringNumberConversions.mjs';
import { toListx6x8nvfmvvht as toList } from '../../../../../../kotlin-kotlin-stdlib/kotlin/sequences/_Sequences.mjs';
import { get_LoadingPageFrame3va2mhcnct771 as get_LoadingPageFrame } from './LoadingPageFrame.mjs';
import { create$ref1r9jms3dtfl6y as create$ref } from './LoadingPageFramePropsExtentions.mjs';
import { FrameRunner3h5m8z872haq7 as FrameRunner } from '../../../../../../Coupling-client-components/com/zegreatrob/coupling/client/components/FrameRunnerKt.mjs';
import {
  setDefaultKeyykye56baz645 as setDefaultKey,
  addChildNodeajp8y977cuss as addChildNode,
  addChildspxcpid5g99g as addChild,
} from '../../../../../../kotlin-react/react/ChildrenBuilder.mjs';
import { ReactHTML_instance1fv1xc01x8ngo as ReactHTML_instance } from '../../../../../../kotlin-react-dom/react/dom/html/ReactHTML.mjs';
import { LoadingPageFramekinq1a7dkzpq as LoadingPageFrame } from './LoadingPageFrameKt.mjs';
import { lazy2hsh8ze7j6ikd as lazy } from '../../../../../../kotlin-kotlin-stdlib/kotlin/kotlin.mjs';
import { FC2myqnqrb760jo as FC } from '../../../../../../kotlin-react/react/FC.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
function get_loadingSequence() {
  _init_properties_LoadingPage_kt__kt4xx5();
  var tmp0 = loadingSequence$delegate;
  var tmp = KProperty0();
  // Inline function 'kotlin.getValue' call
  getPropertyCallableRef('loadingSequence', 0, tmp, _get_loadingSequence_$ref_k0wpkt(), null);
  return tmp0.n3();
}
var loadingSequence$delegate;
function get_LoadingPage() {
  _init_properties_LoadingPage_kt__kt4xx5();
  return LoadingPage;
}
var LoadingPage;
function setFrame(setSearchParams, frame) {
  _init_properties_LoadingPage_kt__kt4xx5();
  var tmp = (params) => {
    params.set('frame', '' + frame);
    return params;
  };
  // Inline function 'js.objects.unsafeJso' call
  setSearchParams(tmp, {});
}
var LoadingAnimationStateDataClass;
function LoadingAnimationStateData() {
  if (LoadingAnimationStateDataClass === VOID) {
    class $ {
      constructor(player1Tilt, player1Top, player1Left, player2Tilt, player2Top, swapped, player2Left) {
        this.l7l_1 = player1Tilt;
        this.m7l_1 = player1Top;
        this.n7l_1 = player1Left;
        this.o7l_1 = player2Tilt;
        this.p7l_1 = player2Top;
        this.q7l_1 = swapped;
        this.r7l_1 = player2Left;
      }
      toString() {
        return 'LoadingAnimationStateData(player1Tilt=' + toString(this.l7l_1) + ', player1Top=' + toString(this.m7l_1) + ', player1Left=' + toString(this.n7l_1) + ', player2Tilt=' + toString(this.o7l_1) + ', player2Top=' + toString(this.p7l_1) + ', swapped=' + this.q7l_1 + ', player2Left=' + toString(this.r7l_1) + ')';
      }
      hashCode() {
        var result = hashCode(this.l7l_1);
        result = imul(result, 31) + hashCode(this.m7l_1) | 0;
        result = imul(result, 31) + hashCode(this.n7l_1) | 0;
        result = imul(result, 31) + hashCode(this.o7l_1) | 0;
        result = imul(result, 31) + hashCode(this.p7l_1) | 0;
        result = imul(result, 31) + getBooleanHashCode(this.q7l_1) | 0;
        result = imul(result, 31) + hashCode(this.r7l_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof LoadingAnimationStateData()))
          return false;
        if (!equals(this.l7l_1, other.l7l_1))
          return false;
        if (!equals(this.m7l_1, other.m7l_1))
          return false;
        if (!equals(this.n7l_1, other.n7l_1))
          return false;
        if (!equals(this.o7l_1, other.o7l_1))
          return false;
        if (!equals(this.p7l_1, other.p7l_1))
          return false;
        if (!(this.q7l_1 === other.q7l_1))
          return false;
        if (!equals(this.r7l_1, other.r7l_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'LoadingAnimationStateData');
    LoadingAnimationStateDataClass = $;
  }
  return LoadingAnimationStateDataClass;
}
var InitialClass;
function Initial() {
  if (InitialClass === VOID) {
    class $ extends LoadingAnimationState() {
      constructor() {
        Initial_instance = null;
        // Inline function 'web.cssom.deg' call
        // Inline function 'js.reflect.unsafeCast' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp = toString(-8) + 'deg';
        // Inline function 'web.cssom.px' call
        // Inline function 'js.reflect.unsafeCast' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp_0 = toString(0) + 'px';
        // Inline function 'web.cssom.px' call
        // Inline function 'js.reflect.unsafeCast' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp_1 = toString(0) + 'px';
        // Inline function 'web.cssom.deg' call
        // Inline function 'js.reflect.unsafeCast' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp_2 = toString(8) + 'deg';
        // Inline function 'web.cssom.px' call
        // Inline function 'js.reflect.unsafeCast' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp_3 = toString(0) + 'px';
        // Inline function 'web.cssom.px' call
        // Inline function 'js.reflect.unsafeCast' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp$ret$20 = toString(0) + 'px';
        super(new (LoadingAnimationStateData())(tmp, tmp_0, tmp_1, tmp_2, tmp_3, false, tmp$ret$20));
        Initial_instance = this;
      }
      toString() {
        return 'Initial';
      }
      hashCode() {
        return -355037244;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof Initial()))
          return false;
        return true;
      }
    }
    initMetadataForObject($, 'Initial');
    InitialClass = $;
  }
  return InitialClass;
}
var Initial_instance;
function Initial_getInstance() {
  if (Initial_instance === VOID)
    new (Initial())();
  return Initial_instance;
}
var Step1Class;
function Step1() {
  if (Step1Class === VOID) {
    class $ extends LoadingAnimationState() {
      constructor() {
        Step1_instance = null;
        // Inline function 'web.cssom.deg' call
        // Inline function 'js.reflect.unsafeCast' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp0_player1Tilt = toString(-4) + 'deg';
        // Inline function 'web.cssom.px' call
        // Inline function 'js.reflect.unsafeCast' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp1_player1Top = toString(-20) + 'px';
        // Inline function 'web.cssom.px' call
        // Inline function 'js.reflect.unsafeCast' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp2_player1Left = toString(20) + 'px';
        // Inline function 'web.cssom.deg' call
        // Inline function 'js.reflect.unsafeCast' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp3_player2Tilt = toString(4) + 'deg';
        // Inline function 'web.cssom.px' call
        // Inline function 'js.reflect.unsafeCast' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp4_player2Top = toString(20) + 'px';
        // Inline function 'web.cssom.px' call
        // Inline function 'js.reflect.unsafeCast' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp5_player2Left = toString(-20) + 'px';
        super(new (LoadingAnimationStateData())(tmp0_player1Tilt, tmp1_player1Top, tmp2_player1Left, tmp3_player2Tilt, tmp4_player2Top, false, tmp5_player2Left));
        Step1_instance = this;
      }
      toString() {
        return 'Step1';
      }
      hashCode() {
        return -1036768411;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof Step1()))
          return false;
        return true;
      }
    }
    initMetadataForObject($, 'Step1');
    Step1Class = $;
  }
  return Step1Class;
}
var Step1_instance;
function Step1_getInstance() {
  if (Step1_instance === VOID)
    new (Step1())();
  return Step1_instance;
}
var Step2Class;
function Step2() {
  if (Step2Class === VOID) {
    class $ extends LoadingAnimationState() {
      constructor() {
        Step2_instance = null;
        // Inline function 'web.cssom.deg' call
        // Inline function 'js.reflect.unsafeCast' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp0_player1Tilt = toString(0) + 'deg';
        // Inline function 'web.cssom.px' call
        // Inline function 'js.reflect.unsafeCast' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp1_player1Top = toString(-35) + 'px';
        // Inline function 'web.cssom.px' call
        // Inline function 'js.reflect.unsafeCast' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp2_player1Left = toString(35) + 'px';
        // Inline function 'web.cssom.deg' call
        // Inline function 'js.reflect.unsafeCast' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp3_player2Tilt = toString(0) + 'deg';
        // Inline function 'web.cssom.px' call
        // Inline function 'js.reflect.unsafeCast' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp4_player2Top = toString(35) + 'px';
        // Inline function 'web.cssom.px' call
        // Inline function 'js.reflect.unsafeCast' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp5_player2Left = toString(-35) + 'px';
        super(new (LoadingAnimationStateData())(tmp0_player1Tilt, tmp1_player1Top, tmp2_player1Left, tmp3_player2Tilt, tmp4_player2Top, false, tmp5_player2Left));
        Step2_instance = this;
      }
      toString() {
        return 'Step2';
      }
      hashCode() {
        return -1036768410;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof Step2()))
          return false;
        return true;
      }
    }
    initMetadataForObject($, 'Step2');
    Step2Class = $;
  }
  return Step2Class;
}
var Step2_instance;
function Step2_getInstance() {
  if (Step2_instance === VOID)
    new (Step2())();
  return Step2_instance;
}
var Step3Class;
function Step3() {
  if (Step3Class === VOID) {
    class $ extends LoadingAnimationState() {
      constructor() {
        Step3_instance = null;
        // Inline function 'web.cssom.deg' call
        // Inline function 'js.reflect.unsafeCast' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp0_player1Tilt = toString(4) + 'deg';
        // Inline function 'web.cssom.px' call
        // Inline function 'js.reflect.unsafeCast' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp1_player1Top = toString(-10) + 'px';
        // Inline function 'web.cssom.px' call
        // Inline function 'js.reflect.unsafeCast' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp2_player1Left = toString(60) + 'px';
        // Inline function 'web.cssom.deg' call
        // Inline function 'js.reflect.unsafeCast' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp3_player2Tilt = toString(-4) + 'deg';
        // Inline function 'web.cssom.px' call
        // Inline function 'js.reflect.unsafeCast' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp4_player2Top = toString(10) + 'px';
        // Inline function 'web.cssom.px' call
        // Inline function 'js.reflect.unsafeCast' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp5_player2Left = toString(-60) + 'px';
        super(new (LoadingAnimationStateData())(tmp0_player1Tilt, tmp1_player1Top, tmp2_player1Left, tmp3_player2Tilt, tmp4_player2Top, false, tmp5_player2Left));
        Step3_instance = this;
      }
      toString() {
        return 'Step3';
      }
      hashCode() {
        return -1036768409;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof Step3()))
          return false;
        return true;
      }
    }
    initMetadataForObject($, 'Step3');
    Step3Class = $;
  }
  return Step3Class;
}
var Step3_instance;
function Step3_getInstance() {
  if (Step3_instance === VOID)
    new (Step3())();
  return Step3_instance;
}
var SwappedClass;
function Swapped() {
  if (SwappedClass === VOID) {
    class $ extends LoadingAnimationState() {
      constructor() {
        Swapped_instance = null;
        // Inline function 'web.cssom.deg' call
        // Inline function 'js.reflect.unsafeCast' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp0_player1Tilt = toString(8) + 'deg';
        // Inline function 'web.cssom.px' call
        // Inline function 'js.reflect.unsafeCast' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp1_player1Top = toString(0) + 'px';
        // Inline function 'web.cssom.px' call
        // Inline function 'js.reflect.unsafeCast' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp2_player1Left = toString(0) + 'px';
        // Inline function 'web.cssom.deg' call
        // Inline function 'js.reflect.unsafeCast' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp3_player2Tilt = toString(-8) + 'deg';
        // Inline function 'web.cssom.px' call
        // Inline function 'js.reflect.unsafeCast' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp4_player2Top = toString(0) + 'px';
        // Inline function 'web.cssom.px' call
        // Inline function 'js.reflect.unsafeCast' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp5_player2Left = toString(0) + 'px';
        super(new (LoadingAnimationStateData())(tmp0_player1Tilt, tmp1_player1Top, tmp2_player1Left, tmp3_player2Tilt, tmp4_player2Top, true, tmp5_player2Left));
        Swapped_instance = this;
      }
      toString() {
        return 'Swapped';
      }
      hashCode() {
        return 180226844;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof Swapped()))
          return false;
        return true;
      }
    }
    initMetadataForObject($, 'Swapped');
    SwappedClass = $;
  }
  return SwappedClass;
}
var Swapped_instance;
function Swapped_getInstance() {
  if (Swapped_instance === VOID)
    new (Swapped())();
  return Swapped_instance;
}
var Step5Class;
function Step5() {
  if (Step5Class === VOID) {
    class $ extends LoadingAnimationState() {
      constructor() {
        Step5_instance = null;
        // Inline function 'web.cssom.deg' call
        // Inline function 'js.reflect.unsafeCast' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp0_player2Tilt = toString(-4) + 'deg';
        // Inline function 'web.cssom.px' call
        // Inline function 'js.reflect.unsafeCast' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp1_player2Top = toString(-20) + 'px';
        // Inline function 'web.cssom.px' call
        // Inline function 'js.reflect.unsafeCast' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp2_player2Left = toString(20) + 'px';
        // Inline function 'web.cssom.deg' call
        // Inline function 'js.reflect.unsafeCast' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp3_player1Tilt = toString(4) + 'deg';
        // Inline function 'web.cssom.px' call
        // Inline function 'js.reflect.unsafeCast' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp4_player1Top = toString(20) + 'px';
        // Inline function 'web.cssom.px' call
        // Inline function 'js.reflect.unsafeCast' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp5_player1Left = toString(-20) + 'px';
        super(new (LoadingAnimationStateData())(tmp3_player1Tilt, tmp4_player1Top, tmp5_player1Left, tmp0_player2Tilt, tmp1_player2Top, true, tmp2_player2Left));
        Step5_instance = this;
      }
      toString() {
        return 'Step5';
      }
      hashCode() {
        return -1036768407;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof Step5()))
          return false;
        return true;
      }
    }
    initMetadataForObject($, 'Step5');
    Step5Class = $;
  }
  return Step5Class;
}
var Step5_instance;
function Step5_getInstance() {
  if (Step5_instance === VOID)
    new (Step5())();
  return Step5_instance;
}
var Step6Class;
function Step6() {
  if (Step6Class === VOID) {
    class $ extends LoadingAnimationState() {
      constructor() {
        Step6_instance = null;
        // Inline function 'web.cssom.deg' call
        // Inline function 'js.reflect.unsafeCast' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp0_player1Tilt = toString(0) + 'deg';
        // Inline function 'web.cssom.px' call
        // Inline function 'js.reflect.unsafeCast' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp1_player1Top = toString(35) + 'px';
        // Inline function 'web.cssom.px' call
        // Inline function 'js.reflect.unsafeCast' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp2_player1Left = toString(-35) + 'px';
        // Inline function 'web.cssom.deg' call
        // Inline function 'js.reflect.unsafeCast' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp3_player2Tilt = toString(0) + 'deg';
        // Inline function 'web.cssom.px' call
        // Inline function 'js.reflect.unsafeCast' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp4_player2Top = toString(-35) + 'px';
        // Inline function 'web.cssom.px' call
        // Inline function 'js.reflect.unsafeCast' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp5_player2Left = toString(35) + 'px';
        super(new (LoadingAnimationStateData())(tmp0_player1Tilt, tmp1_player1Top, tmp2_player1Left, tmp3_player2Tilt, tmp4_player2Top, true, tmp5_player2Left));
        Step6_instance = this;
      }
      toString() {
        return 'Step6';
      }
      hashCode() {
        return -1036768406;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof Step6()))
          return false;
        return true;
      }
    }
    initMetadataForObject($, 'Step6');
    Step6Class = $;
  }
  return Step6Class;
}
var Step6_instance;
function Step6_getInstance() {
  if (Step6_instance === VOID)
    new (Step6())();
  return Step6_instance;
}
var Step7Class;
function Step7() {
  if (Step7Class === VOID) {
    class $ extends LoadingAnimationState() {
      constructor() {
        Step7_instance = null;
        // Inline function 'web.cssom.deg' call
        // Inline function 'js.reflect.unsafeCast' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp0_player1Tilt = toString(-4) + 'deg';
        // Inline function 'web.cssom.px' call
        // Inline function 'js.reflect.unsafeCast' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp1_player1Top = toString(10) + 'px';
        // Inline function 'web.cssom.px' call
        // Inline function 'js.reflect.unsafeCast' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp2_player1Left = toString(-60) + 'px';
        // Inline function 'web.cssom.deg' call
        // Inline function 'js.reflect.unsafeCast' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp3_player2Tilt = toString(4) + 'deg';
        // Inline function 'web.cssom.px' call
        // Inline function 'js.reflect.unsafeCast' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp4_player2Top = toString(-10) + 'px';
        // Inline function 'web.cssom.px' call
        // Inline function 'js.reflect.unsafeCast' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp5_player2Left = toString(60) + 'px';
        super(new (LoadingAnimationStateData())(tmp0_player1Tilt, tmp1_player1Top, tmp2_player1Left, tmp3_player2Tilt, tmp4_player2Top, true, tmp5_player2Left));
        Step7_instance = this;
      }
      toString() {
        return 'Step7';
      }
      hashCode() {
        return -1036768405;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof Step7()))
          return false;
        return true;
      }
    }
    initMetadataForObject($, 'Step7');
    Step7Class = $;
  }
  return Step7Class;
}
var Step7_instance;
function Step7_getInstance() {
  if (Step7_instance === VOID)
    new (Step7())();
  return Step7_instance;
}
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      constructor() {
        Companion_instance = this;
        this.s7l_1 = listOf([new (Pair())(Step1_getInstance(), 100), new (Pair())(Step2_getInstance(), 100), new (Pair())(Step3_getInstance(), 100), new (Pair())(Swapped_getInstance(), 100), new (Pair())(Swapped_getInstance(), 100), new (Pair())(Swapped_getInstance(), 100), new (Pair())(Swapped_getInstance(), 100), new (Pair())(Step5_getInstance(), 100), new (Pair())(Step6_getInstance(), 100), new (Pair())(Step7_getInstance(), 100), new (Pair())(Initial_getInstance(), 100), new (Pair())(Initial_getInstance(), 100), new (Pair())(Initial_getInstance(), 100), new (Pair())(Initial_getInstance(), 100)]);
      }
      s7j() {
        // Inline function 'kotlin.collections.map' call
        var this_0 = numberRangeToNumber(1, 100);
        // Inline function 'kotlin.collections.mapTo' call
        var destination = ArrayList().h2(collectionSizeOrDefault(this_0, 10));
        var inductionVariable = this_0.q3_1;
        var last = this_0.r3_1;
        if (inductionVariable <= last)
          do {
            var item = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            var tmp$ret$2 = Companion_getInstance().s7l_1;
            destination.i2(tmp$ret$2);
          }
           while (!(item === last));
        var tmp0 = flatten(destination);
        var tmp2 = new (Frame())(Initial_getInstance(), 0);
        var tmp$ret$3;
        $l$block: {
          // Inline function 'kotlin.collections.runningFold' call
          var estimatedSize = collectionSizeOrDefault(tmp0, 9);
          if (estimatedSize === 0) {
            tmp$ret$3 = listOf_0(tmp2);
            break $l$block;
          }
          // Inline function 'kotlin.apply' call
          var this_1 = ArrayList().h2(estimatedSize + 1 | 0);
          this_1.i2(tmp2);
          var result = this_1;
          var accumulator = tmp2;
          var _iterator__ex2g4s = tmp0.p1();
          while (_iterator__ex2g4s.q1()) {
            var element = _iterator__ex2g4s.r1();
            var frame = accumulator;
            var state = element.ze();
            var time = element.af();
            accumulator = new (Frame())(state, frame.t3p_1 + time | 0);
            result.i2(accumulator);
          }
          tmp$ret$3 = result;
        }
        return asSequence(tmp$ret$3);
      }
    }
    initMetadataForCompanion($);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance;
function Companion_getInstance() {
  if (Companion_instance === VOID)
    new (Companion())();
  return Companion_instance;
}
var LoadingAnimationStateClass;
function LoadingAnimationState() {
  if (LoadingAnimationStateClass === VOID) {
    class $ {
      constructor(data) {
        Companion_getInstance();
        this.t7l_1 = data;
      }
    }
    initMetadataForClass($, 'LoadingAnimationState');
    LoadingAnimationStateClass = $;
  }
  return LoadingAnimationStateClass;
}
function loadingSequence$delegate$lambda() {
  _init_properties_LoadingPage_kt__kt4xx5();
  return Companion_getInstance().s7j();
}
function _get_loadingSequence_$ref_k0wpkt() {
  return constructCallableReference(() => get_loadingSequence(), 0, 0, 257);
}
function LoadingPage$lambda($this$FC) {
  _init_properties_LoadingPage_kt__kt4xx5();
  var _destruct__k2r9zo = useSearchParams();
  // Inline function 'js.array.component1' call
  var searchParams = _destruct__k2r9zo.at(0);
  // Inline function 'js.array.component2' call
  var setSearchParams = _destruct__k2r9zo.at(1);
  var tmp0_safe_receiver = searchParams.get('frame');
  var frameIndex = tmp0_safe_receiver == null ? null : toIntOrNull(tmp0_safe_receiver);
  var tmp;
  if (frameIndex == null) {
    tmp = null;
  } else {
    // Inline function 'kotlin.let' call
    tmp = toList(get_loadingSequence()).r2(frameIndex);
  }
  var currentFrame = tmp;
  if (!(currentFrame == null)) {
    setDefaultKey($this$FC, '@rdk/24_8');
    // Inline function 'react.dom.html.ReactHTML.button' call
    // Inline function 'react.IntrinsicType' call
    // Inline function 'js.reflect.unsafeCast' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    // Inline function 'react.ChildrenBuilder.invoke' call
    var block = ($this$button) => {
      $this$button.onClick = (it) => {
        setFrame(setSearchParams, frameIndex - 1 | 0);
        return Unit_instance;
      };
      // Inline function 'react.ChildrenBuilder.unaryPlus' call
      // Inline function 'react.ReactNode' call
      // Inline function 'js.reflect.unsafeCast' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      addChildNode($this$button, '<');
      return Unit_instance;
    };
    addChild($this$FC, 'button', block);
    setDefaultKey($this$FC, '@rdk/28_8');
    // Inline function 'react.dom.html.ReactHTML.button' call
    // Inline function 'react.IntrinsicType' call
    // Inline function 'js.reflect.unsafeCast' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    // Inline function 'react.ChildrenBuilder.invoke' call
    var block_0 = ($this$button) => {
      $this$button.onClick = (it) => {
        setFrame(setSearchParams, frameIndex + 1 | 0);
        return Unit_instance;
      };
      // Inline function 'react.ChildrenBuilder.unaryPlus' call
      // Inline function 'react.ReactNode' call
      // Inline function 'js.reflect.unsafeCast' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      addChildNode($this$button, '>');
      return Unit_instance;
    };
    addChild($this$FC, 'button', block_0);
    LoadingPageFrame($this$FC, currentFrame.s3p_1);
  } else {
    var tmp_0 = get_loadingSequence();
    FrameRunner($this$FC, tmp_0, 1.0, create$ref(get_LoadingPageFrame()));
  }
  return Unit_instance;
}
var properties_initialized_LoadingPage_kt_hn1mbp;
function _init_properties_LoadingPage_kt__kt4xx5() {
  if (!properties_initialized_LoadingPage_kt_hn1mbp) {
    properties_initialized_LoadingPage_kt_hn1mbp = true;
    loadingSequence$delegate = lazy(loadingSequence$delegate$lambda);
    var tmp0 = memo(FC(LoadingPage$lambda));
    // Inline function 'seskar.react.internal.withDisplayName' call
    var displayName = 'LoadingPage';
    if (process.env.NODE_ENV !== 'production') {
      // Inline function 'kotlin.js.asDynamic' call
      if (!tmp0.displayName) {
        // Inline function 'kotlin.js.asDynamic' call
        tmp0.displayName = displayName;
      }
    }
    LoadingPage = tmp0;
  }
}
//region block: exports
export {
  get_LoadingPage as get_LoadingPage24k3wu9brtgnx,
};
//endregion

//# sourceMappingURL=LoadingPage.mjs.map
